import React, { memo, useEffect, useRef, useState } from "react";
import { DatePicker } from "antd";
import dayjs from "dayjs";

export default memo(({ value, onValueChange, stopEditing }) => {
  const [dateValue, setDateValue] = useState(value ? dayjs(value) : null);
  const refContainer = useRef(null);

  useEffect(() => {
    refContainer.current?.focus();
  }, []);

  // Handle Enter/Escape key to stop editing
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Enter" || event.key === "Escape") {
        stopEditing();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [stopEditing]);

  const handleChange = (date) => {
    setDateValue(date);
    if (onValueChange) {
      onValueChange(date ? date.format("YYYY-MM-DDTHH:mm:ss") : "");
    }
  };

  const handleOpenChange = (open) => {
    if (!open) {
      stopEditing();
    }
  };

  return (
    <div ref={refContainer} tabIndex={1} style={{ display: "inline-block", width: "100%" }}>
      <DatePicker
        showTime
        value={dateValue}
        onChange={handleChange}
        open={true}
        onOpenChange={handleOpenChange}
        format="DD/MM/YYYY HH:mm"
        style={{ width: "100%" }}
        autoFocus
      />
    </div>
  );
});